import productCardIni from "./productCardIni";
import store from "../store";
import {fetchVisitorByUUID} from "../reduxLib/visitorLib";
import {
    addItemToShoppingCard,
    deleteShoppingCard,
    fetchShoppingCardByVisitorRelID,
    removeItemFromShoppingCard
} from "../reduxLib/shoppingcardLib";


function removeFromCart(productId) {

    const cart = productCardIni();

    const updatedCart = cart.filter(item => item.id !== productId);
    store
        .dispatch(fetchVisitorByUUID(localStorage.getItem("vid")))
        .unwrap()
        .then(visitor => {
            console.log("Visitor:", visitor);
            return store
                .dispatch(fetchShoppingCardByVisitorRelID(visitor.visitorID))
                .unwrap();
        })
        .then(shoppingCard => {
            console.log("ShoppingCard:", shoppingCard);
            return store
                .dispatch(
                    removeItemFromShoppingCard({
                        cardId: shoppingCard.shoppingCardId,
                        itemId: productId,
                    })
                )
                .unwrap();
        })
        .then(result => {
            console.log("AddItem result:", result);
        })
        .catch(err => {
            console.error("ERROR:", err);
        });

    localStorage.setItem("productCard", JSON.stringify(updatedCart));
}

export default removeFromCart;